import { ProviderFilterTypes } from 'dataSource/ProviderSearch'

export const initialGlobalValue: GlobalReducerType = {
  globalGroupedFilters: {
    [ProviderFilterTypes.AVAILABILITY_TYPE]: [],
    [ProviderFilterTypes.AREA_OF_CONCERN]: [],
    [ProviderFilterTypes.LANGUAGE]: [],
    [ProviderFilterTypes.COUNSELING_APPROACH]: [],
    [ProviderFilterTypes.CLIENT_AGE_GROUP]: [],
    [ProviderFilterTypes.GENDER]: [],
    [ProviderFilterTypes.COUNSELING_TYPE]: [],
    [ProviderFilterTypes.TAG]: [],
  },
}

export const UPDATE_GROUPED_FILTERS = 'UPDATE_GROUPED_FILTERS'

export const SET_BOOKING_ATTRIBUTION = 'SET_BOOKING_ATTRIBUTION'

export const BOOKING_MEDIUM_LABELS = {
  sms: 'Self-booking SMS',
  email: 'Self-booking Email',
} as const
